import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { API_GET_CLIENT_BY_EMAIL } from '../../utils/constants';

// Hardcoded client data (kept for development reference - not used in production)
// This was causing a bug where hardcoded data appeared on refresh
// Solution: Changed initialState to null to force proper loading flow
const HARDCODED_CLIENT_REFERENCE = {
  contentStrategy:
    'ce41946d74ddad9950d063a07b161237eb3ad41317378b1db38d6fd168d1d50f',
  businessHours: {
    sunday: '/',
    saturday: '/',
    tuesday: '9/18',
    wednesday: '9/18',
    thursday: '9/18',
    friday: '9/18',
    monday: '8/15'
  },
  tier: 'pro',
  yelpId: '8275f78f6465421cbce846fe555cf784',
  timeZone: 'Eastern Daylight Time - (GMT-4)',
  appUid: '3I9flIBzoGa4adTRgPXj0SaNzxi1',
  gmbId: 'a0ff59a4eadc4653877fe0a455569d9a',
  countPosts: {
    Posts: 116,
    Scheduled: 0,
    Draft: 75
  },
  description: 'test,,,,',
  brand: {
    primaryColor: '#3B5998',
    secondaryColor: '#8392A5'
  },
  yelpInfo: {
    createdAt: '2024-05-23T13:15:07.000Z',
    clicks: 2,
    id: '8275f78f6465421cbce846fe555cf784',
    slashtag: 'xqs7',
    shortUrl: 'yelp-review.link/xqs7',
    domainName: 'yelp-review.link'
  },
  industry: 'b783686ecaec2be76f895a073248b4091fe4448857a71aae33ed42836fb7e8f9',
  socialnetworks: {
    twFailing: false,
    fbFailing: false,
    facebookPage: 'Samxlabs',
    googleMyBusiness: true,
    googleMyBusinessLocationName: 'SamXLabs',
    zoho: true,
    facebook: true,
    igFailing: false,
    instagram: true,
    zohoId: '3359678000108767002',
    instagramPage: 'SamXLabs',
    gmbFailing: false
  },
  imagesTrained: true,
  mergeFields: {
    '~Address': '7630 NW 25 Street',
    '~BestService': '',
    '~BestProduct': '',
    '~City': 'Miami',
    '~Phone': '(305) 501-7090',
    '~OpenHours': '08:00',
    '~Website': 'samxlabs.com',
    '~Name': '(Test Account) SamXLabs',
    '~BestDish': '',
    '~CloseHours': '18:00',
    '~Email': 'christian@samxlabs.co'
  },
  negativeKeywords: [],
  accountOwner: '3359678000163912001',
  clientGroups: [
    {
      groupName: 'Generic',
      id: 'a04e292905c344580e83ba63f3cf199278d1654b6013a65085ea1ec3e898cece'
    }
  ],
  id: '6cb8166a97eb01d30036bd60028956c30be3405ad27218dd651d059a146c30be',
  appActive: true,
  clientFlags: ['NO_FB', 'NO_AI', 'NO_GMB', 'NO_REVIEWS', 'NO_IG'],
  fbTags: ['AWS'],
  singlePerson: true,
  gmbInfo: {
    createdAt: '2023-11-15T18:02:58.000Z',
    clicks: 9,
    id: 'a0ff59a4eadc4653877fe0a455569d9a',
    slashtag: 'f4y',
    shortUrl: 'google-review.link/f4y',
    domainName: 'google-review.link'
  },
  primaryService: [
    'AWS Bedrock',
    'AWS',
    'AI Modern Development',
    'Serverless LLM inference',
    'AWS cloud services',
    'Artificial Intelligence Cursor'
  ],
  generationStartedAt: 1768232726386,
  generatingContentByAI: false,
  galleries: {
    yelp: {
      enabled: true
    },
    appLibrary: {
      enabled: true
    },
    dropbox: {
      enabled: true
    },
    gmb: {
      enabled: true
    },
    stockPhotos: {
      enabled: true
    }
  },
  bestTimes: {
    Monday: '07',
    Thursday: '07',
    Friday: '07',
    Sunday: '08',
    Wednesday: '07',
    Tuesday: '07',
    Saturday: '07'
  },
  igTags: ['AWS'],
  attributes: [],
  clientName: '(Test Account) SamXLabs',
  postsAppCount: 65,
  smsCount: 0,
  createdAt: 1698150576132,
  imageTrainedCount: 13,
  serviceArea: ['Bogotá D.C'],
  accountStatus: null,
  automaticReviews: true,
  firstGenerationByAI: false,
  currentClientBestTimes: {
    Monday: '07',
    Thursday: '07',
    Friday: '07',
    Sunday: '08',
    Wednesday: '07',
    Tuesday: '07',
    Saturday: '07'
  },
  currentClientMergeFields: {
    '~Address': '7630 NW 25 Street',
    '~BestService': '',
    '~BestProduct': '',
    '~City': 'Miami',
    '~Phone': '(305) 501-7090',
    '~OpenHours': '08:00',
    '~Website': 'samxlabs.com',
    '~Name': '(Test Account) SamXLabs',
    '~BestDish': '',
    '~CloseHours': '18:00',
    '~Email': 'christian@samxlabs.co'
  },
  currentClientId:
    '6cb8166a97eb01d30036bd60028956c30be3405ad27218dd651d059a146c30be',
  clientSocialNetworks: {
    facebook: true,
    google: true,
    twitter: false,
    instagram: true,
    zoho: true
  }
};

// Async thunk para cargar el cliente por email
export const fetchClientByEmail = createAsyncThunk(
  'selectedClient/fetchByEmail',
  async (email, { rejectWithValue }) => {
    try {
      // Normalizar email a minúsculas (el backend es case-sensitive)
      let emailToFetch = email.toLowerCase();

      // Hack: Determinar qué email usar según el dominio
      if (
        emailToFetch.endsWith('@adlerlocal.com') ||
        emailToFetch.endsWith('@adlersocial.com')
      ) {
        emailToFetch = 'robin@adlerlocal.com';
      } else if (emailToFetch.endsWith('@samxlabs.com')) {
        emailToFetch = 'app-prod@samxlabs.com';
      }

      // Crear controller para timeout
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 10000); // 10 segundos timeout

      const response = await fetch(API_GET_CLIENT_BY_EMAIL, {
        method: 'POST',
        headers: {
          accept: 'application/json, text/plain, */*',
          'accept-language': 'en-US,en;q=0.9,es-ES;q=0.8,es;q=0.7',
          'content-type': 'application/json'
        },
        body: JSON.stringify({ email: emailToFetch }),
        signal: controller.signal
      });

      clearTimeout(timeoutId);

      if (!response.ok) {
        throw new Error(`Error al obtener cliente: ${response.status}`);
      }

      const clientData = await response.json();
      return clientData;
    } catch (error) {
      if (error.name === 'AbortError') {
        return rejectWithValue(
          'Timeout: El servidor tardó demasiado en responder'
        );
      }
      return rejectWithValue(error.message);
    }
  }
);

const slice = createSlice({
  name: 'selectedClient',
  initialState: {
    selectedClient: null,
    loading: false,
    error: null
  },
  reducers: {
    setCurrentClient: (state, { payload }) => {
      // Merge payload with default values to ensure all required properties exist
      const defaultValues = {
        clientSocialNetworks: {
          facebook: false,
          google: false,
          twitter: false,
          instagram: false,
          zoho: false
        },
        timeZone: 'Eastern Daylight Time - (GMT-4)',
        bestTimes: {},
        mergeFields: {},
        clientGroups: [],
        contentStrategy: '',
        clientName: '',
        id: '',
        logoUrl: null,
        noAutomaticContent: false
      };

      state.selectedClient = {
        ...defaultValues,
        ...payload,
        clientSocialNetworks: {
          ...defaultValues.clientSocialNetworks,
          ...(payload.clientSocialNetworks || payload.socialnetworks || {})
        },
        bestTimes: {
          ...defaultValues.bestTimes,
          ...(payload.bestTimes || {})
        },
        mergeFields: {
          ...defaultValues.mergeFields,
          ...(payload.mergeFields || {})
        }
      };
    },
    clearSelectedClient: (state) => {
      state.selectedClient = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchClientByEmail.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchClientByEmail.fulfilled, (state, action) => {
        state.loading = false;
        const defaultValues = {
          clientSocialNetworks: {
            facebook: false,
            google: false,
            twitter: false,
            instagram: false,
            zoho: false
          },
          timeZone: 'Eastern Daylight Time - (GMT-4)',
          bestTimes: {},
          mergeFields: {},
          clientGroups: [],
          contentStrategy: '',
          clientName: '',
          id: '',
          logoUrl: null,
          noAutomaticContent: false
        };

        state.selectedClient = {
          ...defaultValues,
          ...action.payload,
          clientSocialNetworks: {
            ...defaultValues.clientSocialNetworks,
            ...(action.payload.clientSocialNetworks ||
              action.payload.socialnetworks ||
              {})
          },
          bestTimes: {
            ...defaultValues.bestTimes,
            ...(action.payload.bestTimes || {})
          },
          mergeFields: {
            ...defaultValues.mergeFields,
            ...(action.payload.mergeFields || {})
          }
        };
      })
      .addCase(fetchClientByEmail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Error al cargar el cliente';
      });
  }
});

export default slice.reducer;

const { setCurrentClient, clearSelectedClient: clearSelectedClientAction } =
  slice.actions;

// Current client selector
export const selectedClientSelector = (state) => state.selectedClient;

export const setSelectedClient = (payload) => (dispatch) => {
  dispatch(setCurrentClient(payload));
};

export const clearSelectedClient = () => (dispatch) => {
  dispatch(clearSelectedClientAction());
};
